import React, { useContext } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Button from 'react-bootstrap/lib/Button';
import ProgressBar from 'react-bootstrap/lib/ProgressBar';
import { LinkContainer } from 'react-router-bootstrap';
import { AuthContext } from '../components/Auth';

export function Home(props) {
  const { user, isLoading } = props;
  const { login } = useContext(AuthContext);

  if (isLoading) {
    return <ProgressBar now={100} active={true} />;
  }

  if (!user) {
    return (
      <div>
        <Helmet title="Payment Gateway" />

        <Grid>
          <Row>
            <Col md={6} xs={12} mdOffset={3}>
              <Button onClick={login} bsStyle="primary" bsSize="large" block>
                Login
              </Button>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }

  return (
    <div>
      <Helmet title="Home" />

      <Grid>
        <Row>
          <Col md={8} xs={12} mdOffset={2}>
            <LinkContainer to="/api-keys">
              <Button
                bsStyle="default"
                bsSize="large"
                block
                className="home-container-link-container"
              >
                Manage Api Keys
              </Button>
            </LinkContainer>
          </Col>
        </Row>
      </Grid>
    </div>
  );
}

export default connect(({ auth }) => ({
  user: auth.user,
  isLoading: auth.isLoading,
}))(Home);



// WEBPACK FOOTER //
// ./src/containers/Home.js